module.exports = window._qiwa && window._qiwa.sys_global || (function () {
	console.log('当前页面没有 _qiwa.sys_global 对象');
	return {};
})();


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-static/sys_global.js
// module id = 188
// module chunks = 4